<h2 mat-dialog-title>Link Sharing</h2>

<mat-dialog-content>
    <div class="link-display">{{ data.url }}</div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()">
        Close
    </button>

    <button mat-button (click)="copyLink()">
        <mat-icon>content_copy</mat-icon>
        Copy Link
    </button>

    <button mat-button (click)="openLink()">
        <mat-icon>open_in_new</mat-icon>
        Open
    </button>
</mat-dialog-actions>
